// extracted by mini-css-extract-plugin
module.exports = {"container":"df","content":"dg","image":"dh","text":"di","form":"dj","button":"dk"};